export default [
    {
      path: "comision",
      name: "empleados-comision",
      component: () =>
        import( /* webpackChunkName: "empleados-comision" */ "@/views/comision/views/index.vue" ),
    },
    
    
]